import { Goal } from '@griply/types';
import { createContext } from 'react';

export type GoalMetricsFormContextProps = {
  onOpenMetricsForm: (goal: Goal) => void;
};

export const GoalMetricsFormContext =
  createContext<GoalMetricsFormContextProps>({
    onOpenMetricsForm: () => {},
  });
